import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import './UserOrderDetailModal.css';

/* User-facing order detail. Fetches GET /api/user/orders/:id — the backend
   only returns the order if it belongs to the authenticated wallet (404
   otherwise), so a user can never open another wallet's order. */
const UserOrderDetailModal = ({ orderId, onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!orderId) return undefined;
    let cancelled = false;
    setLoading(true); setData(null); setError('');
    api.get(`/user/orders/${orderId}`)
      .then((r) => { if (!cancelled) setData(r.data); })
      .catch((e) => { if (!cancelled) setError(e?.response?.data?.message || e?.message || 'Failed to load order'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [orderId]);

  if (!orderId) return null;

  const usd = (v, cur) => `$${Number(v || 0).toFixed(2)}${cur ? ` ${cur}` : ''}`;

  return (
    <div className="uod-overlay" onClick={onClose}>
      <div className="uod-modal" onClick={(e) => e.stopPropagation()}>
        <button className="uod-close" type="button" onClick={onClose} aria-label="Close">×</button>
        {loading ? (
          <div className="uod-empty">Loading…</div>
        ) : error ? (
          <div className="uod-error">{error}</div>
        ) : data ? (
          <>
            <span className="uod-eyebrow">Order {data.order_id || '—'}</span>
            <h4 className="uod-title">{data.service_name}</h4>
            <div className="uod-grid">
              <div><em>Status</em><b>{data.status}</b></div>
              <div><em>Quantity</em><b>{Number(data.quantity || 0).toLocaleString()}</b></div>
              <div><em>Remaining</em><b>{data.remains != null ? Number(data.remains).toLocaleString() : '—'}</b></div>
              <div><em>Start count</em><b>{data.start_count != null ? Number(data.start_count).toLocaleString() : '—'}</b></div>
              <div><em>Charged</em><b>{usd(data.charged_usd, data.payment_currency || 'USDT')}</b></div>
              <div><em>Placed</em><b>{data.created_at ? new Date(data.created_at).toLocaleString() : '—'}</b></div>
              {data.refund_state && data.refund_state !== 'none' && (
                <div><em>Refund</em><b>{data.refund_state} · {usd(data.refunded_usd)}</b></div>
              )}
            </div>
            {data.link && (
              <div className="uod-link">
                <em>Target link</em>
                <a href={data.link} target="_blank" rel="noopener noreferrer">{data.link}</a>
              </div>
            )}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default UserOrderDetailModal;
